import { render, staticRenderFns } from "./EnvironmentalMatters.vue?vue&type=template&id=b3efe6e8&"
import script from "./EnvironmentalMatters.vue?vue&type=script&lang=js&"
export * from "./EnvironmentalMatters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports